<script>
  import { isApp } from '@st-graphics/graphics-kit/environment'
  import { boolean } from '@st-graphics/graphics-kit/utils'
  import { CarouselStack, Credits, Headline, Navbar } from '@st-graphics/graphics-components'

  const { head, sections, credits: creditsProps } = $props()

  const cards = $derived(
    sections[0].blocks.map((block) => {
      return {
        type: block.type,
        ...block.value,
      }
    }),
  )

  const hideRestart = $derived.by(() => {
    const creditCard = cards.find((card) => ['creditcard', 'quizcreditcard'].includes(card.type))

    return boolean(creditCard?.hiderestart)
  })
</script>

<div class="discover-container" style:--st-topbar="linear-gradient(to right, {head.gradient})">
  {#if !isApp}
    <Navbar seamless={true} gradient={false} overlap={true} />
  {/if}

  <CarouselStack {cards} hiderestart={hideRestart}>
    {#snippet head()}
      <Headline
        hed={head.headline}
        dek={head.deck}
        byline={head.byline}
        datetime={head.datetime}
        modifieddatetime={head.modifieddatetime}
      />
    {/snippet}

    {#snippet credits()}
      <Credits {...creditsProps} />
    {/snippet}
  </CarouselStack>
</div>

<style lang="scss">
  :global {
    .st-page:has(.discover-container) {
      grid-template-rows: minmax(0, 1fr) auto !important;
      height: 100vh;

      @supports (height: 100dvh) {
        height: 100dvh;
      }

      .st-content {
        display: flex;
        flex-direction: column;
        min-height: 0;

        .main,
        .article {
          display: flex;
          flex: 1 1 auto;
          flex-direction: column;
          min-height: 0;
        }
      }

      .footer {
        border-top: 0;
        color: var(--st-white-primary);
      }

      & > .footer {
        display: none;

        @media (min-width: $screen-md) {
          display: block;
        }
      }
    }

    .is-app .st-page:has(.discover-container) {
      grid-template-rows: minmax(0, 1fr) !important;
    }
  }

  .discover-container {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    width: 100%;

    @media (min-width: $screen-md) {
      padding-top: 70px;
    }

    &::before {
      position: absolute;
      content: '';
      display: block;
      flex: none;
      top: 0;
      left: 0;
      width: 100%;
      height: 6px;
      background: var(--st-topbar);
      z-index: 2;
    }

    :global(.navbar) {
      top: 5px;
    }
  }
</style>
